import React from "react";
import { Select, Checkbox } from "antd";

import PropTypes from "prop-types";


function MultiSelectOption({ checked, label }) {
  return (
    <Checkbox
      checked={checked}
      style={{ marginRight: 10, pointerEvents: 'none' }}
    >
      {label}
    </Checkbox>
  );
}

export default function MultiSelect({
  value,
  onChange,
  options,
  placeholder,
  dropdownClassName,
  style,
  t,
}) {
  const renderOption = (option) => (
    <MultiSelectOption checked={value.includes(option.value)} label={option.label} />
  );

  let displayLabel = null;
  if (value.length > 0) {
    if (value.includes('all') || value.length === options.length) {
      displayLabel = `${placeholder} (All)`;
    } else {
      displayLabel = `${placeholder} (${value.filter(v => v !== 'all').length})`;
    }
  }

  return (
    <div style={{ position: 'relative', minWidth: 180, maxWidth: 220, ...style }}>
      <Select
        mode="multiple"
        allowClear
        showArrow
        showSearch={false}
        placeholder={placeholder}
        value={value}
        // onChange still needed for allowClear (clears all selections)
        onChange={(vals) => {
          if (!vals.length) onChange([]);
        }}
        onSelect={(val) => {
          const allValues = options.map((o) => o.value);
          const nonAllValues = options.filter((o) => o.value !== 'all').map((o) => o.value);

          if (val === 'all') {
            // Selecting 'all' selects every value (including 'all')
            onChange(allValues);
            return;
          }

          // Add selected value (remove sentinel 'all' first if present)
          const set = new Set(value.filter((v) => v !== 'all'));
          set.add(val);
          const current = Array.from(set);
          const allNonAllSelected = nonAllValues.every((v) => set.has(v));
          onChange(allNonAllSelected ? allValues : current);
        }}
        onDeselect={(val) => {
          if (val === 'all') {
            // Deselecting 'all' clears everything
            onChange([]);
            return;
          }
          // Remove val and also remove 'all' sentinel if present
          const remaining = value.filter((v) => v !== val && v !== 'all');
          onChange(remaining);
        }}
        options={options}
        className={dropdownClassName}
        style={{ minWidth: 180, maxWidth: 220, ...style }}
        optionLabelProp="label"
        dropdownStyle={{ borderRadius: 12, minWidth: 220 }}
        maxTagCount={0}
        tagRender={() => null}
        optionRender={renderOption}
      />
      {displayLabel && (
        <div
          style={{
            position: 'absolute',
            left: 12,
            top: 0,
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            pointerEvents: 'none',
            fontSize: 15,
            background: 'transparent',
          }}
        >
          {displayLabel}
        </div>
      )}
    </div>
  );
}

MultiSelect.propTypes = {
  value: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.node.isRequired,
    })
  ).isRequired,
  placeholder: PropTypes.string,
  dropdownClassName: PropTypes.string,
  style: PropTypes.object,
  t: PropTypes.func,
};

MultiSelectOption.propTypes = {
  checked: PropTypes.bool.isRequired,
  label: PropTypes.node.isRequired,
};
